import axios from 'axios';
import { metaCaching } from '../../../modules/utils/MetaData';

export const KindergartenReestrViewApi = {
  loadMetaData: metaDataKey => metaCaching(`/api/public/metadata/${metaDataKey}`),
  loadData: id => axios.get(`/api/public/passport/service_provider/${id}`)
};
